<template>
    <app-framework>
        <template v-slot:title>
            <div v-if="!!fields">
                {{ fields.title }}
            </div>
        </template>
        <loader v-if="loading"></loader>
        <div style="max-width: 1200px; width: 100%;" id="content"></div>
    </app-framework>
</template>

<script>
    import {documentToHtmlString} from "@contentful/rich-text-html-renderer";

    export default {
        name: "DataProcessorAgreement",
        components: {
            'app-framework': () => import('@/components/layout/AppFramework.vue'),
            'loader': () => import('@/components/display/Loader.vue'),
        },
        data: () => ({
            fields: null,
            loading: true
        }),
        mounted() {
            this.$contentful.getEntry('2NWE0zZZs81pBxk4nJM1zz').then((resp) => {
                this.fields = resp.fields;
                return documentToHtmlString(this.fields.content);
            }).then((renderedHtml) => {
                document.getElementById('content').innerHTML = renderedHtml;
                this.loading = false;
            });
        }
    }
</script>

<style>
    p {
        padding-bottom: 15px;
    }

    h1 {
        font-size: 2em;
    }

    h2 {
        font-size: 1.5em;
    }

    ul {
        list-style:outside disc;
        margin-left: 17px;
    }
</style>